<template>
    <v-btn
        v-bind="$attrs"
        icon
        :input-value="isActive"
        text
        :small="buttonSmall"
        class="mr-0 ml-0 rounded-lg"
        :color="isActive ? 'main' : color"
        :x-small="xSmall"
        v-on="on"
        @click="$emit('click', $event)"
    >
        <icon
            v-if="icon"
            :icon="icon"
            :small="small"
            :x-small="xSmall"
            :size="iconSize"
            :color="isActive ? 'main' : color"
        />
        <v-icon
            v-else
            :size="iconSize"
            :color="isActive ? 'main' : color"
        >
            <slot />
        </v-icon>
    </v-btn>
</template>

<script>
export default {
    // NOTE: currently it is intended that you use the icon prop to pass in the icon not the slot. The slot is for supporting old mdi icons. However the new lucide icons work only from the prop
    name: "IconButtonVue",
    props: {
        on: {
            type: Object,
            default: null
        },
        small: {
            type: Boolean,
            default: null
        },
        buttonSmall: {
            type: Boolean,
            default: null
        },
        iconSize: {
            type: [String, Number],
            default: 24
        },
        xSmall: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: "n3"
        },
        icon: {
            type: String,
            default: null
        },
        isActive: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">
    .v-btn {
        &:hover {
            &::before {
                opacity: 0.25;
            }

        }

        &:focus {
            &::before {
                opacity: 0.5 !important;
            }
        }

        &.n3--text {
            &:hover {
                .v-icon {
                    color: var(--v-n4-base) !important;
                }
            }

            &:focus {
                .v-icon {
                    color: var(--v-n5-base) !important;
                }
            }
        }
    }
</style>